export default [
    {
        path: 'alteracao-exame-finalizado',
        component: () => import(
            /* webpackChunkName: 'exame-imagem-alteracao-exame-finalizado' */
            '@/views/exame-imagem/alteracao-exame-finalizado/Index'
        ),
        redirect: 'alteracao-exame-finalizado/create',
        children: [
            {
                name: 'exame-imagem-alteracao-exame-finalizado-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'exame-imagem-alteracao-exame-finalizado' */
                    '@/views/exame-imagem/alteracao-exame-finalizado/Form.vue'),
            },
        ]
    }
]